/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-bank-list',
  templateUrl: './../../../templates/forms/modals/hr-company-list.component.html',
})
export class HrCompanyListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrCompanyListId"

  companyList:any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.companyName, field: 'COMPANY_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.companyAlias, field: 'COMPANY_ALIAS', sortable: true, resizable: true, hide: false }
      ];
    }

  ngOnInit() {  
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_SA_COMM_EMP_COMPANY').subscribe(results=>{
      this.companyList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

} 